import { PersonalDocumentType } from '../enums';
import { RgDocument } from './rg-document.class';

export class PersonalDocument {
  [PersonalDocumentType.CPF]: string;
  [PersonalDocumentType.RG]: RgDocument;
}
